/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectProfileShare = (state: State) => state.profileShare.profileShare

export const selectProfileShareId = compose(
  (profileShare) => profileShare.profile_share_id,
  selectProfileShare
)
